import { useState } from "react";
import { login } from "../services/authService";
import { useDispatch } from 'react-redux';
import {setLocationEnabled, setUser} from "../store/authSlice"
import { showToast } from "../store/uiSlice";
import { adminUrl } from "../Utils";
import { removeUserCoordinate } from "../services/locationService";


function PulseIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="rgba(255,255,255,0.85)"
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#aaa"
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

// ─── Login Screen ─────────────────────────────────────────────
function LoginScreen({ onSuccess }) {
  const [selectedRole, setSelectedRole] = useState("phleb");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim() || !password.trim()) {
      setError("Please enter your email and password.");
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await login({email: email, password:password});
      if (res?.data?.success !== false) {
          dispatch(setUser(res?.data));
          localStorage.setItem("isLoggedIn", true);
        }
        else if(res?.data?.success === false) { 
          setError('Invalid credentials.')
        }
    } catch (error) {
        onSuccess(selectedRole);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = () => {
    window.open(`${adminUrl}/forgot-password?isField=true`, "_blank");
  }

  return (
    <>
      {/* Hero */}
      <div className="login-hero">
        <div className="login-hero-icon">
          <PulseIcon />
        </div>
        <div className="login-logo">ReyaGo</div>
        <div className="login-logo-sub">Specimen Logistics</div>
        <div className="login-tagline">
          Coordinating specimen collection
          <br />
          across 40+ skilled nursing facilities
        </div>
      </div>

      {/* Form */}
      <div className="login-form-area">

        {/* Email */}
        <div className="login-form-group">
          <label className="login-form-label">Email</label>
          <input
            className="login-form-input"
            type="text"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {/* Password */}
        <div className="login-form-group">
          <label className="login-form-label">Password</label>
          <div className="login-input-wrap">
            <input
              className="login-form-input with-eye"
              type={showPw ? "text" : "password"}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            />
            <button
              className="login-eye-btn"
              onClick={() => setShowPw((v) => !v)}
              tabIndex={-1}
            >
              <EyeIcon /> 
            </button>
          </div>
        </div>

        {/* Error */}
        {error && <div className="login-error">{error}</div>}

        {/* CTA */}
        <button className="login-sign-in-btn" onClick={handleSubmit} disabled={loading}
          style={{ opacity: loading ? 0.8 : 1 }}>
          Sign In
        </button>

        {/* Forgot */}
        <div className="login-forgot">
          <a style={{cursor: "pointer"}} onClick={handleNavigate}>Forgot password?</a>
        </div>
      </div>

      <div className="login-version">ReyaGo v2.0 · CIMPAR Lab Services</div>
    </>
  );
}

// ─── Root Component ───────────────────────────────────────────
export default function LoginView() {
  const [screen, setScreen] = useState("login");
  const [role, setRole] = useState("phleb");

  const handleSuccess = (selectedRole) => {
    setRole(selectedRole);
    setScreen("success");
  };
  return  <LoginScreen onSuccess={handleSuccess} />
}